module.exports = __webpack_public_path__ + "img/login-illustration.a7842280.png";